import * as React from "react";
import { format } from "date-fns";
import { confirmAlert } from "react-confirm-alert";

import { IControlError, IControlSchema } from "../../core/Controls";

import { IDispatcher } from "../helpers/Dispatcher";
import { Component, I18NString } from "../helpers/Utils";
import GetDeveloperModal from "../../core/modal/GetDeveloperModal";

export interface ITkpLinksSchema extends IControlSchema {
	description: I18NString;
	extra: any;
}

export interface ITkpLinksProps {
	schema: ITkpLinksSchema;
	api?: any;
	dispatcher?: IDispatcher;
	error: IControlError | undefined;
	visited: boolean;
	opts: any;
}

interface IState {
	data:
		| {
				active: boolean;
				email: string;
				form_type: string;
				link: string;
				process_id: number;
				tkp_id: number;
				created_at: string;
		  }[]
		| null;
	error: string | null;
}

// TODO REFACTOR (Компонент слишком уникальный для проекта, его нужно будет вынести за metajson и подключать)
class TkpLinks extends Component<ITkpLinksProps, IState> {
	developerModal;

	state = {
		data: null,
		error: null,
	};

	constructor(props) {
		super(props);
		this.onDeleteDeveloperTKP = this.onDeleteDeveloperTKP.bind(this);
		this.handleCreate = this.handleCreate.bind(this);
		this.developerModal = GetDeveloperModal;
	}

	componentDidMount() {
		const { api } = this.props;
		this.onLoadTkp(api.options.process_id);
	}

	onLoadTkp = (process_id: string) => {
		const { api } = this.props;
		api?.getTkp(process_id, {
			success: (data) => {
				if (data.length > 0) {
					this.setState({
						data,
					});
				} else {
					this.setState({
						data,
						error: "Не удалось получить ни одной заявки ТКП",
					});
				}
			},
			error: () => {
				this.setState({
					error: "Не удалось получить ни одной заявки ТКП",
				});
			},
		});
	};

	onDeleteDeveloperTKP(event: React.MouseEvent<HTMLButtonElement>, formType, tkpId: number) {
		const { api } = this.props;
		event.stopPropagation();
		event.preventDefault();

		if (window.confirm("Удалить ТКП?")) {
			api.deleteDeveloperTKP(tkpId, {
				success: () => {
					this.onLoadTkp(api.options.process_id);
				},
				error: (_error, _response) => {
					confirmAlert({
						message: "Не удалось удалить ТКП",
						buttons: [
							{
								label: "Продолжить",
								// eslint-disable-next-line @typescript-eslint/no-empty-function
								onClick: () => {},
							},
						],
					});
				},
			});
		}
	}

	getDeveloperModal = (e, processId: string, ownerEmail?) => {
		e.stopPropagation();
		e.preventDefault();

		this.developerModal.show(processId, ownerEmail);
	};

	// eslint-disable-next-line consistent-return
	handleCreate = (processId: string, value: string) => {
		const { api } = this.props;

		api?.inviteDeveloper(processId, value, {
			success: () => {
				this.onLoadTkp(processId);
				this.setState({
					error: null,
				});
			},
		});
	};

	render() {
		const {
			schema,
			opts: {
				ext_rules: { FORMS_URL },
			},
			api: {
				options: { process_id },
			},
		} = this.props;
		const { data, error } = this.state;

		if (!data) return null;
		return (
			<div>
				<div style={{ marginBottom: "10px" }}>
					{schema?.title?.ru ? <span style={{ marginRight: "10px" }}>{schema.title.ru}</span> : null}
					<button
						type="button"
						className="btn btn-primary"
						onClick={(event) => this.getDeveloperModal(event, process_id)}
					>
						Запросить ТКП
					</button>
				</div>
				{!error ? (
					<div className="list-group">
						{data
							.filter((item) => item.active)
							.map((item) => (
								<a
									key={item.tkp_id}
									href={FORMS_URL ? FORMS_URL({ form_type: item.form_type, process_id: item.tkp_id }) : "#!"}
									className="list-group-item"
									style={{ display: "flex", justifyContent: "space-between" }}
								>
									ТКП №{item.tkp_id} от {format(new Date(item.created_at), "dd.MM.yyyy")}
									<button
										type="button"
										className="btn btn-danger"
										onClick={(event) => this.onDeleteDeveloperTKP(event, item.form_type, item.tkp_id)}
									>
										Удалить
									</button>
								</a>
							))}
					</div>
				) : (
					<div className="alert alert-danger" role="alert">
						{error}
					</div>
				)}
				<GetDeveloperModal
					ref={(modal) => {
						this.developerModal = modal;
					}}
					func={this.handleCreate}
					api={this.props.api}
				/>
			</div>
		);
	}
}

export function createTkpLinks(
	schema: IControlSchema,
	api: any,
	dispatcher: IDispatcher = null,
	error: IControlError | undefined,
	visited: boolean,
	opts: any
): React.ReactElement<any> {
	return (
		<TkpLinks
			schema={schema as ITkpLinksSchema}
			api={api}
			dispatcher={dispatcher}
			error={error}
			visited={visited}
			opts={opts}
		/>
	);
}
